var _g, _rect, _g2, _g3, _path, _path2, _path3, _g4, _rect2, _g5, _g6, _path4, _path5, _path6, _g7, _rect3, _g8, _g9, _path7, _path8, _path9, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 35,
    viewBox: "0 0 45 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_131_12492)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.64917,
    y: 17.6613,
    width: 18.1389,
    height: 25.3781,
    rx: 5.30319,
    transform: "rotate(-48.0945 0.64917 17.6613)",
    fill: "#9220CE"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.58528,
    y: 17.6106,
    width: 16.8131,
    height: 24.0523,
    rx: 4.64029,
    transform: "rotate(-48.0945 1.58528 17.6106)",
    stroke: "black",
    strokeWidth: 1.3258
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_131_12492)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.23401,
    y: 17.4663,
    width: 13.06,
    height: 20.3025,
    rx: 2.6516,
    transform: "rotate(-48.0945 4.23401 17.4663)",
    fill: "#9254D7"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_131_12492)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8466 20.9634C10.1953 20.3789 10.1412 19.3772 10.7256 18.7259L14.9089 14.0645C15.4934 13.4132 16.4951 13.359 17.1464 13.9435C17.8206 14.5485 18.3278 15.3168 18.6193 16.1745L20.0098 20.265C20.2665 21.0202 20.0956 21.8552 19.5628 22.4488C19.0301 23.0425 18.2184 23.3024 17.4399 23.1286L13.2233 22.1873C12.3392 21.9899 11.5208 21.5684 10.8466 20.9634Z",
    fill: "#663B96"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1718 20.068C12.8963 19.8208 12.8734 19.397 13.1206 19.1216L15.5605 16.4027C15.8078 16.1273 16.2315 16.1044 16.507 16.3516C16.7847 16.6008 16.9955 16.9156 17.1203 17.2673L17.9252 19.5363C18.0749 19.9583 17.9819 20.4284 17.6829 20.7616C17.3838 21.0949 16.9265 21.238 16.4909 21.1346L14.1483 20.579C13.7852 20.4929 13.4495 20.3172 13.1718 20.068Z",
    fill: "#9254D7"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.19347 11.94L5.90389 15.6056L6.09356 19.1351L9.75679 22.4226L9.19347 11.94Z",
    fill: "white",
    fillOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2682 26.4712L11.9306 24.3734L11.1455 9.76477L11.9876 8.82643C12.3511 8.42144 12.9843 8.25859 13.3753 8.36574L14.2682 26.4712Z",
    fill: "white",
    fillOpacity: 0.6
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_131_12492)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.6829,
    y: 4.0387,
    width: 18.1791,
    height: 25.408,
    rx: 5.30319,
    transform: "rotate(-12.3622 10.6829 4.0387)",
    fill: "#FFA402"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.4723,
    y: 4.5443,
    width: 16.8533,
    height: 24.0822,
    rx: 4.64029,
    transform: "rotate(-12.3622 11.4723 4.5443)",
    stroke: "black",
    strokeWidth: 1.3258
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_131_12492)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.7129,
    y: 5.97571,
    width: 13.089,
    height: 20.3264,
    rx: 2.6516,
    transform: "rotate(-12.3622 13.7129 5.97571)",
    fill: "#F9D11F"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_i_131_12492)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0441 12.6831C16.8566 11.8277 17.398 10.9823 18.2535 10.7948L24.3897 9.44992C25.2451 9.26243 26.0905 9.8039 26.278 10.6593C26.4723 11.5456 26.4351 12.467 26.17 13.3348L24.9066 17.4713C24.6731 18.2359 24.0452 18.8151 23.2643 18.9863C22.4833 19.1574 21.6708 18.894 21.1389 18.2971L18.2612 15.0682C17.6575 14.3908 17.2383 13.5694 17.0441 12.6831Z",
    fill: "#AE9216"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4728 13.5748C19.3935 13.213 19.6225 12.8554 19.9844 12.7761L23.5626 11.9918C23.9245 11.9125 24.2821 12.1416 24.3614 12.5034C24.4414 12.8685 24.4286 13.2478 24.3242 13.6067L23.6507 15.921C23.5253 16.3519 23.1745 16.6798 22.7361 16.7759C22.2977 16.872 21.8419 16.7208 21.5478 16.3819L19.9681 14.5615C19.7231 14.2792 19.5528 13.9399 19.4728 13.5748Z",
    fill: "#F9D11F"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9822 4.38247L16.1605 5.43925L14.2484 8.41922L15.3035 13.2328L20.9822 4.38247Z",
    fill: "white",
    fillOpacity: 0.6
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6027 19.1609L15.9295 16.0893L23.8435 3.75536L25.0777 3.48484C25.6105 3.36808 26.2209 3.60588 26.4762 3.92151L16.6027 19.1609Z",
    fill: "white",
    fillOpacity: 0.6
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_i_131_12492)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.1277,
    y: 1.83533,
    width: 18.5831,
    height: 24.9174,
    rx: 5.30319,
    transform: "rotate(26.1175 28.1277 1.83533)",
    fill: "#1057DA"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 28.4311,
    y: 2.72236,
    width: 17.2573,
    height: 23.5916,
    rx: 4.64029,
    transform: "rotate(26.1175 28.4311 2.72236)",
    stroke: "black",
    strokeWidth: 1.3258
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_131_12492)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.3667,
    y: 5.2179,
    width: 13.3798,
    height: 19.934,
    rx: 2.6516,
    transform: "rotate(26.1175 29.3667 5.2179)",
    fill: "black"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_i_131_12492)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.9103 12.4098C28.282 11.6516 29.198 11.3383 29.9562 11.71L35.8871 14.6178C36.6453 14.9895 36.9586 15.9055 36.5869 16.6637C36.1881 17.477 35.5798 18.1694 34.8245 18.6695L31.2953 21.0063C30.6119 21.4588 29.74 21.5151 29.0041 21.1544C28.2683 20.7936 27.7788 20.0698 27.718 19.2525L27.404 15.0314C27.3368 14.1281 27.5116 13.2231 27.9103 12.4098Z",
    fill: "#0087AA"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4558 14.423C29.613 14.1023 30.0005 13.9698 30.3212 14.127L33.7532 15.8096C34.0739 15.9669 34.2065 16.3543 34.0492 16.6751C33.8849 17.0103 33.6363 17.2971 33.3279 17.5074L31.3793 18.8358C30.9992 19.095 30.5092 19.1299 30.0962 18.9274C29.6831 18.7249 29.4107 18.3162 29.3827 17.857L29.2396 15.503C29.2169 15.1304 29.2914 14.7582 29.4558 14.423Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1972 8.56671L31.6666 6.34546L28.2868 7.42062L26.1593 11.7599L36.1972 8.56671Z",
    fill: "white",
    fillOpacity: 0.6
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5394 17.1038L24.8969 14.3349L38.8857 9.88483L40.0455 10.4534C40.5461 10.6988 40.8899 11.2639 40.9001 11.6653L23.5394 17.1038Z",
    fill: "white",
    fillOpacity: 0.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_131_12492",
    x: 2.83484,
    y: 6.34717,
    width: 26.6312,
    height: 27.4043,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.3258,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_innerShadow_131_12492"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.3258
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "hard-light",
    in2: "shape",
    result: "effect1_innerShadow_131_12492"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_131_12492",
    x: 4.33256,
    y: 8.83923,
    width: 22.6414,
    height: 22.0887,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.331449,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_131_12492"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.662899,
    dy: 0.662899
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.590983 0 0 0 0 0.590983 0 0 0 0 0.590983 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_131_12492"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_131_12492",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_131_12492",
    x: 10.3203,
    y: 13.5382,
    width: 9.80688,
    height: 9.64343,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.662899
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_131_12492"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_131_12492",
    x: 11.6941,
    y: 1.15796,
    width: 21.1747,
    height: 28.0142,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.3258,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_innerShadow_131_12492"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.3258
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "hard-light",
    in2: "shape",
    result: "effect1_innerShadow_131_12492"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_131_12492",
    x: 13.2242,
    y: 3.67908,
    width: 17.1202,
    height: 22.6405,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.331449,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_131_12492"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.662899,
    dy: 0.662899
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.590983 0 0 0 0 0.590983 0 0 0 0 0.590983 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_131_12492"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_131_12492",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_i_131_12492",
    x: 17.007,
    y: 9.41284,
    width: 9.39355,
    height: 9.62476,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.662899
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_131_12492"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_i_131_12492",
    x: 18.9506,
    y: 3.6272,
    width: 24.0709,
    height: 28.2958,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.3258,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_innerShadow_131_12492"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.3258
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "hard-light",
    in2: "shape",
    result: "effect1_innerShadow_131_12492"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_131_12492",
    x: 20.4931,
    y: 6.11377,
    width: 19.9914,
    height: 22.9911,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.331449,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_131_12492"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.662899,
    dy: 0.662899
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.590983 0 0 0 0 0.590983 0 0 0 0 0.590983 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_131_12492"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_131_12492",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_i_131_12492",
    x: 27.3899,
    y: 11.5536,
    width: 9.35339,
    height: 9.83655,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.662899
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_131_12492"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.fdd1e9404234d3018301e96b78585aba.svg";
export { ForwardRef as ReactComponent };